import { Tree, Modal, Dropdown, Popconfirm, Input, message, Alert, Tooltip } from "antd";
import {
  UploadOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleFilled,
  EditOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { useState, createRef } from "react";
import {
  createFileOrFolder,
  deleteFileOrFolder,
  renameIdeFileOrFolder,
  servUploadFileToS3
} from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";
import { trackEvent } from "./util-functions";
import {handleDownloadProject} from "../ide/download-ide-project"
import { ReactComponent as CreateFileIcon } from '../../assets/logos/create file.svg';
import { ReactComponent as CreateFolderIcon } from '../../assets/logos/create folder.svg';
import './file-manager.css'

const FileManager = (props) => {
  const [showNewFileDialog, setShowNewFileDialog] = useState(false);
  const [showNewFolderDialog, setshowNewFolderDialog] = useState(false);
  const [fileSavingProgress, setFileSavingProgress] = useState(false);
  const [newFileOrFolderName, setNewFileOrFolderName] = useState("");
  const [treeData, setTreeData] = useState(props.fileStructure);
  const [selectedUploadNode, setSelectedUploadNode] = useState(undefined);

  const inputFileRef = createRef();
  const inputNodeFileRef = createRef();
  const MAX_LENGTH = 40;

  const handleNewFileFolderCancel = () => {
    setNewFileOrFolderName("");
    setShowNewFileDialog(false);
    setshowNewFolderDialog(false);
  };

  const handleRenameFile = (node) => (e) => {
    e.domEvent.stopPropagation();

    let newFileName = node.fileName;
    Modal.info({
      title:
        "Rename " +
        (node.isFile ? "file " : "folder ") +
        ((node.path ? node.path + "/" : "") + node.fileName),
      content: (
        <Input
          defaultValue={node.fileName}
          placeholder="Enter new file name"
          onChange={(e) => (newFileName = e.target.value)}
          maxLength={MAX_LENGTH}
        />
      ),
      onOk() {
        if (newFileName.trim() === "") {
          message.error("Please enter a valid file name");
          return;
        }
        if (newFileName.length > MAX_LENGTH) {
          message.error(`The file name exceeds the maximum allowed limit. Use a shorter name`);
          return;
        }

        if (node.fileName === newFileName) {
          return;
        }

        renameIdeFileOrFolder(
          props.ideProjectId,
          node.id,
          newFileName,
          node.isFile
        ).then((response) => {
          response = response.data;

          if (response.statusCode === 200) {
            const updateNode = (tData, fileId, updateObj) => {
              for (let i = 0; i < tData.length; i++) {
                const node = tData[i];
                if (node.id === fileId) {
                  node.fileName = updateObj.fileName;
                  node.fileS3reference = updateObj.fileS3reference;
                  node.fileMimeType = updateObj.fileMimeType;
                  return true;
                }
                if (node.children) {
                  if (updateNode(node.children, fileId, updateObj)) {
                    return true;
                  }
                }
              }
              return false;
            };

            const updatedTreeData = [...treeData];
            updateNode(updatedTreeData, node.id, response.fileMetaListObj);
            setTreeData(updatedTreeData);

            props.handleFileRenamed(updatedTreeData, {
              id: node.id,
              fileMetaListObj: response.fileMetaListObj,
            });

            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  };

  const handleFileUploadToNodeButtonClick = (node) => (e) => {
    !props.readOnlyMode && inputNodeFileRef.current.click();
    setSelectedUploadNode(node)
  };
  
const handleNodeFileUpload = (event_) =>{
    const fileObj = event_.target.files[0];
    const filePath =
        "IDEFiles/" + global_var.user_login_id + "/" + props.ideProjectId + "/" + selectedUploadNode.fileName ;

    const preventRandomNumber = true;
    servUploadFileToS3(fileObj, filePath, preventRandomNumber)
        .then((uploadedResponse) => {
            if (uploadedResponse.status !== "uploaded") {
                console.error("Upload failed:", uploadedResponse.status);
                message.error("Upload failed. Please try again.");
                return;
            }

            const fileKey = uploadedResponse.fileKey;

            return createFileOrFolder(props.ideProjectId, {
                fileOrFolderObject: {
                    fileName: fileObj.name,
                    isFile: true,
                    parentId: selectedUploadNode.id,
                    ancestors: [selectedUploadNode.id].concat(selectedUploadNode.ancestors ? selectedUploadNode.ancestors : []),
                    path: (selectedUploadNode.path ? selectedUploadNode.path : "") + "/" + selectedUploadNode.fileName,
                    fileS3reference:
                        global_var.CLOUD_ASSET_STORAGE_URL +
                        "/" +
                        fileKey,
                },
            });
        }).then((fileResponse) => {
            if (!fileResponse) return;
            fileResponse = fileResponse.data;

            if (fileResponse.statusCode === 200) {
                const insertNode = (tData, parentId, fileMetaListObj) => {
                    for (let i = 0; i < tData.length; i++) {
                        const selectedUploadNode = tData[i];
                        if (selectedUploadNode.id === parentId) {
                            if (!selectedUploadNode.children) {
                                selectedUploadNode.children = [];
                            }
                            selectedUploadNode.children.push(fileMetaListObj);
                            return true;
                        }
                        if (selectedUploadNode.children) {
                            if (insertNode(selectedUploadNode.children, parentId, fileMetaListObj)) {
                                return true;
                            }
                        }
                    }
                    return false;
                };

                const updatedTreeData = [...treeData];
                insertNode(updatedTreeData, selectedUploadNode.id, fileResponse.fileMetaListObj);
                setTreeData(updatedTreeData);

                props.handleNewFile(fileResponse.fileMetaListObj, updatedTreeData);

                message.success(fileResponse.message);
            } else {
                message.error(fileResponse.message);
            }
        })
        .catch((err) => {
            console.error("File upload failed:", err);
            message.error("Something went wrong while uploading.");
        });
};
  const handleNewFileOnChildren = (node) => (e) => {
    e.domEvent.stopPropagation();

    let fileOrFolderName = "";
    Modal.info({
      title: "Create file",
      content: (
        <Input
          placeholder="Enter file name"
          onChange={(e) => (fileOrFolderName = e.target.value)}
        />
      ),
      onOk() {
        if (fileOrFolderName.trim() === "") {
          message.error("Please enter a valid file name");
          return;
        }
        if (fileOrFolderName.length > MAX_LENGTH) {
          message.error(`The file name exceeds the maximum allowed limit. Use a shorter name`);
          return;
        }

        createFileOrFolder(props.ideProjectId, {
          fileOrFolderObject: {
            fileName: fileOrFolderName,
            isFile: true,
            parentId: node.id,
            ancestors: [node.id].concat(node.ancestors ? node.ancestors : []),
            path: (node.path ? node.path : "") + "/" + node.fileName,
          },
        }).then((response) => {
          response = response.data;

          if (response.statusCode === 200) {
            const insertNode = (tData, parentId, fileMetaListObj) => {
              for (let i = 0; i < tData.length; i++) {
                const node = tData[i];
                if (node.id === parentId) {
                  if (!node.children) {
                    node.children = [];
                  }
                  node.children.push(fileMetaListObj);
                  return true;
                }
                if (node.children) {
                  if (insertNode(node.children, parentId, fileMetaListObj)) {
                    return true;
                  }
                }
              }
              return false;
            };

            const updatedTreeData = [...treeData];
            insertNode(updatedTreeData, node.id, response.fileMetaListObj);
            setTreeData(updatedTreeData);

            props.handleNewFile(response.fileMetaListObj, updatedTreeData);

            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  };

  const handleNewFileOrFolderOk = (type_) => {
    if (newFileOrFolderName.trim() === "") {
      message.error("Please enter a valid file name");
      return;
    }
    if (newFileOrFolderName.length > MAX_LENGTH) {
      message.error(`The file name exceeds the maximum allowed limit. Use a shorter name`);
      return;
    }

    trackEvent(
      type_ === "file"
        ? "file_manager_new_file_ok_clicked"
        : "file_manager_new_folder_ok_clicked",
      {
        ide_project_stack_name: props.projectStack,
      }
    );

    setFileSavingProgress(true);

    createFileOrFolder(props.ideProjectId, {
      fileOrFolderObject: {
        fileName: newFileOrFolderName,
        isFile: type_ === "file" ? true : false,
        path: "",
      },
    }).then((response) => {
      setFileSavingProgress(false);
      response = response.data;

      if (response.statusCode === 200) {
        message.success(response.message);
        setShowNewFileDialog(false);
        setshowNewFolderDialog(false);

        const updatedTreeData = [...treeData];
        updatedTreeData.push(response.fileMetaListObj);
        setTreeData(updatedTreeData);

        setNewFileOrFolderName("");

        props.handleNewFile(response.fileMetaListObj, updatedTreeData);
      } else {
        message.error(response.message);
      }
    });
  };

  const handleDeleteClicked = (node) => (e) => {
    e.domEvent.stopPropagation();

    Modal.confirm({
      title:
        "Do you want to delete this " + (node.isFile ? "file" : "folder") + "?",
      icon: <ExclamationCircleFilled />,
      content: node.fileName,
      onOk() {
        deleteFileOrFolder(props.ideProjectId, node.id).then((response) => {
          response = response.data;

          if (response.statusCode === 200) {
            const deleteNode = (tData, fileId) => {
              for (let i = 0; i < tData.length; i++) {
                const node = tData[i];
                if (node.id === fileId) {
                  tData.splice(i, 1); // Remove the node from the array
                  return true;
                }
                if (node.children) {
                  if (deleteNode(node.children, fileId)) {
                    return true;
                  }
                }
              }
              return false;
            };

            const updatedTreeData = [...treeData];
            deleteNode(updatedTreeData, node.id);
            setTreeData(updatedTreeData);

            props.handleFileDeleted(node, updatedTreeData);

            message.success(response.message);
          } else {
            message.error(response.message);
          }
        });
      },
    });
  };

  const renderTreeNode = (node) => {
    const { fileName } = node;

    const menuItems = [
      {
        label: "Rename " + (node.isFile ? "File" : "Folder"),
        key: "1",
        icon: <EditOutlined />,
        onClick: handleRenameFile(node),
      },
      {
        label: "Delete " + (node.isFile ? "File" : "Folder"),
        key: "2",
        danger: true,
        icon: <CloseOutlined style={{cursor:"pointer"}} />,
        onClick: handleDeleteClicked(node),
      },
    ];

    if (!node.isFile) {
      menuItems.unshift({
        label: "Create File",
        key: "3",
        icon: <CreateFileIcon style={{cursor:"pointer"}} />,
        onClick: handleNewFileOnChildren(node),
      });
      menuItems.unshift({
        label: "Upload File",
        key: "4",
        icon: <UploadOutlined />,
        onClick: handleFileUploadToNodeButtonClick(node),
      });
    }

    return (
      <Dropdown
        menu={{ items: menuItems }}
        trigger={["contextMenu"]}
        disabled={props.readOnlyMode}
      >
        <span>{fileName}</span>
      </Dropdown>
    );
  };

  const handleButtonClick = () => {
    !props.readOnlyMode && inputFileRef.current.click();
  };
  const handleDownloadClick = () => {
    handleDownloadProject(props.ideProjectDetails);
  };

const handleUpload = (event_) => {
  const fileObj = event_.target.files[0];
  const fileName = fileObj.name;
  // Check if file name exceeds maximum length
  if (fileName.length > MAX_LENGTH) {
    message.error(`File exceeds maximum length of  characters. Please rename the file.`);
    return;
  };
  const filePath =
    "IDEFiles/" + global_var.user_login_id + "/" + props.ideProjectId;
  const preventRandomNumber = true
  servUploadFileToS3(fileObj, filePath, preventRandomNumber)
    .then((uploadedResponse) => {
      if (uploadedResponse.status !== "uploaded") {
        console.error("Upload failed:", uploadedResponse.status);
        message.error("File upload failed.");
        return;
      }

      const fileKey = uploadedResponse.fileKey;

      return createFileOrFolder(props.ideProjectId, {
        fileOrFolderObject: {
          fileName: fileObj.name,
          isFile: true,
          path: "",
          fileS3reference:
            global_var.CLOUD_ASSET_STORAGE_URL +
            "/" +
            fileKey,
        },
      });
    }).then((fileResponse) => {
      if (!fileResponse) return;
      fileResponse = fileResponse.data;

      if (fileResponse.statusCode === 200) {
        const updatedTreeData = [...treeData];
        updatedTreeData.push(fileResponse.fileMetaListObj);
        setTreeData(updatedTreeData);

        message.success(fileResponse.message);
      } else {
        message.error(fileResponse.message);
      }
    })
    .catch((err) => {
      console.error("Upload failed:", err);
      message.error("Something went wrong while uploading.");
    });
};

  return (
    <div>
      <div
        style={{ marginBottom: "16px", border:' 1px solid #F6F6F6' }}
        className="d-flex p-2 rounded justify-content-center"
      >
        <Popconfirm
          title={
            <Input
              placeholder="Enter file name"
              value={newFileOrFolderName}
              onChange={(e) => setNewFileOrFolderName(e.target.value)}
              maxLength={MAX_LENGTH}
              /> 
          }
          open={showNewFileDialog}
          onConfirm={() => handleNewFileOrFolderOk("file")}
          onCancel={handleNewFileFolderCancel}
          okButtonProps={{ loading: fileSavingProgress }}
          okText={<CheckOutlined />}
          cancelText={<CloseOutlined />}
          placement="bottomRight"
          icon={null}
        >
          <Tooltip title="Create File">
            <CreateFileIcon className="file-manager-icon"
              style={{ marginRight: "8px",cursor:'pointer' }}
              onClick={() => !props.readOnlyMode && setShowNewFileDialog(true)}
            />
          </Tooltip>
        </Popconfirm>
        <Popconfirm
          title={
            <Input
              placeholder="Enter folder name"
              value={newFileOrFolderName}
              onChange={(e) => {
                setNewFileOrFolderName(e.target.value.replace(/\./g, ''))}}
              maxLength={40}
            />
          }
          open={showNewFolderDialog}
          onConfirm={() => handleNewFileOrFolderOk("folder")}
          onCancel={handleNewFileFolderCancel}
          okButtonProps={{ loading: fileSavingProgress }}
          okText={<CheckOutlined />}
          cancelText={<CloseOutlined />}
          placement="bottomRight"
          icon={null}
        >
          <Tooltip title="Create Folder">
            <CreateFolderIcon className="file-manager-icon"
              style={{ marginRight: "8px",cursor:'pointer' }}
              onClick={() => !props.readOnlyMode && setshowNewFolderDialog(true)}
            />
          </Tooltip>
        </Popconfirm>
        <input
          type="file"
          ref={inputFileRef}
          style={{ display: "none" }}
          onChange={handleUpload}
          accept={props.uploadAcceptFileTypes}
        />
        <Tooltip title="Upload File">
          <UploadOutlined 
            className="file-manager-icon" 
            onClick={handleButtonClick} 
            style={{marginRight:"10px"}} />
        </Tooltip>
        <Tooltip title="Download Project">
          <DownloadOutlined 
            onClick={handleDownloadClick} 
            className="file-manager-icon"/>
        </Tooltip>
      </div>
      <div>
        <input
          type="file"
          ref={inputNodeFileRef}
          style={{ display: "none" }}
          onChange={handleNodeFileUpload}
          accept={props.uploadAcceptFileTypes}
        />

        <Tree
          showIcon
          showLine
          treeData={treeData}
          titleRender={renderTreeNode}
          fieldNames={{ key: "id" }}
          onSelect={props.nodeSelected}
          defaultSelectedKeys={[props.defaultSelectedKey]}
          defaultExpandAll={true}
        />
        </div>

      {treeData.length === 0 && (
        <Alert message="Please create a file" type="warning" />
      )}
    </div>
  );
};

export default FileManager;
